import React from 'react'
import { useNavigate } from 'react-router'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../../utilities/constants'

const Projects = ({ courseProjects, courseName, setShowOverview, showOverview, courseModule }) => {

    const navigate = useNavigate()
    
    const handleProject = (project)=> {
        Mixpanel.track(constants.Mixpanel.COURSE_LIST_PAGE_CLICKED_ON_PROJECTS)
        if (showOverview){
            setShowOverview(!showOverview)
        }
        navigate(`/${encodeURIComponent(courseName)}/${project}`)
    }
    return (
        
        <div>
            <h2 className='text-2xl font-semibold mb-2'>Projects</h2>
            <div className='flex flex-col gap-4'>
                {courseProjects?.map((item, index) => (
                    <div className='' key={index}>
                        <div className='flex rounded-t-xl border border-b-0 border-white/10 bg-[#17395A] p-3 leading-[17px]'>
                            <div>
                                <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Project_management_4.svg?updatedAt=1685516333321" alt="" />
                            </div>
                            <p className='w-[90%] text-sm font-medium ml-3 leading-[17px]'>{item}</p>
                        </div>
                        <div className='flex rounded-b-xl border border-t-0 border-white/10 bg-[#102D47] p-3'>
                            <div className='flex items-center flex-1'>
                                <div className='flex items-center'>
                                    <div className='w-4 h-4 mr-1'>
                                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Star_21.png?updatedAt=1689150672644" alt="" className='w-full h-full'/>
                                    </div>
                                    <div className='w-4 h-4 mr-1'>
                                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Star_21.png?updatedAt=1689150672644" alt="" className='w-full h-full'/>
                                    </div>
                                    <div className='w-4 h-4 mr-1'>
                                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Star_21.png?updatedAt=1689150672644" alt="" className='w-full h-full'/>
                                    </div>
                                    <div className='w-4 h-4 mr-1'>
                                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Star_21.png?updatedAt=1689150672644" alt="" className='w-full h-full'/>
                                    </div>
                                    <div className='w-4 h-4 mr-1'>
                                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Star_21.png?updatedAt=1689150672644" alt="" className='w-full h-full'/>
                                    </div>
                                </div>
                                <p className='ml-1.5 font-semibold text-sm' style={{
                                    fontFamily: 'Montserrat'
                                }}>?/5</p>
                            </div>
                            <div className={`${courseModule?.course_progress === 100 ? 'bg-[#7FC241] text-[#071D2D]' : 'border border-[#7FC241]'} cursor-pointer rounded-3xl px-3 py-2`} onClick={() => handleProject(item)}>
                                <p className='text-sm font-semibold' style={{
                                    fontFamily: 'Montserrat'
                                }}>Complete Now</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Projects
